import { render, staticRenderFns } from "./DadosGeraisForm.vue?vue&type=template&id=3a1b09f6"
import script from "./DadosGeraisForm.vue?vue&type=script&lang=js"
export * from "./DadosGeraisForm.vue?vue&type=script&lang=js"
import style0 from "./DadosGeraisForm.vue?vue&type=style&index=0&id=3a1b09f6&prod&lang=css"
import style1 from "./../../../../../../../components/editor/style-editor.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports